import { createSlice } from "@reduxjs/toolkit";

//import * as muqabalasActions from "./muqabalas.actions";
import muqabalasAsyncActions from "./muqabalas.asyncActions";

import { IMuqabalasInitialState } from "./muqabalas.interfaces";

const initialState: IMuqabalasInitialState = {
  appointmentSlots: null,
};

export const muqabalasSlice = createSlice({
  name: "muqabalas",
  initialState,
  reducers: {
    //...muqabalasActions,
  },
  extraReducers(builder) {
    muqabalasAsyncActions(builder);
  },
});

export const muqabalasSliceActions = muqabalasSlice.actions;

export default muqabalasSlice.reducer;
